import { render, staticRenderFns } from "./VideoPane.vue?vue&type=template&id=5a2184a6&scoped=true&"
import script from "./VideoPane.vue?vue&type=script&lang=js&"
export * from "./VideoPane.vue?vue&type=script&lang=js&"
import style0 from "./VideoPane.vue?vue&type=style&index=0&id=5a2184a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2184a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
